export interface ILinks {
    _links: ILink[];
}

export interface ILink {
    category: string;
    description: string;
    href: string;
    method: 'GET' | 'POST' | 'PUT' | 'DELETE';
    rel: string;
    actionName: ActionName;
}

export enum ActionName {
    GetPrev = 'GetPrev',
    GetNext = 'GetNext',
    GetFirst = 'GetFirst',
    GetLast = 'GetLast',
    RedirectToStripeConnect = 'RedirectToStripeConnect',
    GetStripeConnectLink = 'GetStripeConnectLink',
}
